import React, { useState } from "react";
import { Box, Checkbox, MenuItem, Select, Typography } from "@mui/material";

import HtmlTooltip from "../../../../components/HtmlTooltip";
import { useCurrentStore } from "../../../../hooks/useCurrentStore";
import { useCurrentCounter } from "../../../../hooks/useCurrentCounter";

export const BillStores = {
  store1: "Store 1",
  store2: "Store 2",
  store3: "Store 3"
} as const;

export const BillCounters = {
  counter1: "Counter 1",
  counter2: "Counter 2",
  counter3: "Counter 3"
} as const;

// eslint-disable-next-line import/prefer-default-export
export const BillLocalSettings = (): React.ReactNode => {
  // use hooks
  const { currentStore, setCurrentStore } = useCurrentStore();
  const { currentCounter, setCurrentCounter } = useCurrentCounter();

  // use states
  const [showDueOnBillPrint, setShowDueOnBillPrint] = useState(
    localStorage.getItem("showDueOnBillPrint") === "true"
  );

  const [automaticallyCalculateRoundOffAmount, setAutomaticallyCalculateRoundOffAmount] = useState(
    localStorage.getItem("automaticallyCalculateRoundOffAmount") === "true"
  );

  return (
    <Box>
      <Box>
        <Typography>
          <Box component="span" fontSize="16px" fontWeight={600}>
            Bill Editor Settings
          </Box>
        </Typography>

        <Box display="flex" alignItems="center" p={0}>
          <Checkbox
            checked={automaticallyCalculateRoundOffAmount}
            onChange={() => {
              const newValue = !automaticallyCalculateRoundOffAmount;
              setAutomaticallyCalculateRoundOffAmount(newValue);
              localStorage.setItem("automaticallyCalculateRoundOffAmount", newValue.toString());
            }}
          />

          <Typography>Automatically calculate round off amount</Typography>
        </Box>
      </Box>

      <Box>
        <Typography>
          <Box component="span" fontSize="16px" fontWeight={600}>
            Bill Print Settings
          </Box>
        </Typography>

        <Box display="flex" alignItems="center" p={0}>
          <Checkbox
            checked={showDueOnBillPrint}
            onChange={() => {
              const newValue = !showDueOnBillPrint;

              setShowDueOnBillPrint(newValue);

              localStorage.setItem("showDueOnBillPrint", newValue.toString());
            }}
          />

          <Typography>Show due on bill print</Typography>
        </Box>
      </Box>

      <Box sx={{ mt: "20px" }}>
        <Typography component="span" fontSize="16px" fontWeight={600}>
          Billing Store
        </Typography>

        <Box display="flex" alignItems="center" px={1}>
          <Select
            variant="outlined"
            id="storeSelect"
            value={currentStore}
            sx={{
              marginLeft: "5px",
              height: "40px",
              width: "180px"
            }}
            error={!currentStore}
            onChange={(e) => {
              setCurrentStore(e.target.value);
            }}
          >
            <MenuItem value="">None</MenuItem>

            {Object.keys(BillStores).map((option) => (
              <MenuItem key={option} value={option}>
                {(BillStores as Record<string, string>)[option]}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>

      <Box sx={{ mt: "20px" }}>
        <Typography
          component="span"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            fontSize: "14px",
            fontWeight: 600
          }}
        >
          Billing Counter (Terminal)
          <HtmlTooltip description="Counterwise billing can be enabled or disabled from the settings tab." />
        </Typography>

        <Box display="flex" alignItems="center" px={1}>
          <Select
            variant="outlined"
            id="counterSelect"
            value={currentCounter}
            sx={{
              marginLeft: "5px",
              height: "40px",
              width: "180px"
            }}
            error={!currentCounter}
            onChange={(e) => {
              setCurrentCounter(e.target.value);
            }}
          >
            <MenuItem value="">None</MenuItem>

            {Object.keys(BillCounters).map((option) => (
              <MenuItem key={option} value={option}>
                {(BillCounters as Record<string, string>)[option]}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>
    </Box>
  );
};
